import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";

// Register Chart.js components
ChartJS.register(ArcElement, Tooltip, Legend);

const ChartPie = ({
  completedPkgColor,
  pendingPkgColor,
  remainingPkgColor,
  height,
  width,
  packageData,
}) => {
  const data = {
    datasets: [
      {
        data: packageData?.length ? packageData : [5, 8, 30],
        borderWidth: 0,
        backgroundColor: [
          `${completedPkgColor ? completedPkgColor : "rgba(226, 52, 40,0.7)"}`,
          `${pendingPkgColor ? pendingPkgColor : "rgba(226, 52, 40,0.5)"}`,
          `${remainingPkgColor ? remainingPkgColor : "rgba(0, 0, 0, 0.07)"}`,
        ],
        hoverBackgroundColor: [
          `${completedPkgColor ? completedPkgColor : "rgba(226, 52, 40,0.7)"}`,
          `${pendingPkgColor ? pendingPkgColor : "rgba(226, 52, 40,0.5)"}`,
          `${remainingPkgColor ? remainingPkgColor : "rgba(0, 0, 0, 0.07)"}`,
        ],
      },
    ],
    labels: ["Total Tour", "Total Hotel", "Total Flight"],
  };

  const options = {
    plugins: {
      legend: false,
      responsive: true,
    },
    maintainAspectRatio: false,
  };

  return (
    <div style={{ height: height || 200, width: width || "auto" }}>
      <Pie data={data} options={options} />
    </div>
  );
};

export default ChartPie;
